"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _core = require("@material-ui/core");
var _mdiMaterialUi = require("mdi-material-ui");
var _SortDropdown = _interopRequireDefault(require("./SortDropdown.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var SortDropdown = function SortDropdown(_ref) {
  var label = _ref.label,
    value = _ref.value,
    onClick = _ref.onClick,
    ascending = _ref.ascending,
    onDirection = _ref.onDirection,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size;
  var classes = (0, _SortDropdown.default)();

  // STYLES
  var cssRoot = (0, _classnames2.default)(classes.root, classes.rootActive, _defineProperty({}, classes.rootSmall, size === 'small'));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cssRoot
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    onClick: onClick,
    className: classes.sortButton,
    tabIndex: -1,
    "data-allow-shortcuts": "false",
    role: "presentation",
    style: {
      width: 'unset'
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.sortLabel
  }, label, ":"), /*#__PURE__*/_react.default.createElement("strong", {
    className: classes.sortValue
  }, value), /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.MenuDown, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.sortDirection,
    onClick: onDirection,
    role: "presentation"
  }, ascending ? /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: "Sort Descending",
    placement: "top"
  }, /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.SortDescending, {
    fontSize: "inherit"
  })) : /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: "Sort Ascending",
    placement: "top"
  }, /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.SortAscending, {
    fontSize: "inherit"
  }))));
};
var _default = SortDropdown;
exports.default = _default;